export default __webpack_public_path__ + "static/media/deductions-icon.b08be6a3.svg";